export default __webpack_public_path__ + "static/media/madeINusa.35926f86.png";